import React from 'react';
const COMPANIES = ['LINEAR', 'VERCEL', 'RAMP', 'RAYCAST', 'SCALE', 'RET00L'];
export function TrustStrip() {
  return <section className="py-10 border-y border-white/5 bg-zinc-950/50" data-id="element-223">
      <div className="max-w-7xl mx-auto px-6" data-id="element-224">
        <p className="text-center text-sm font-mono text-zinc-500 mb-6 uppercase tracking-widest" data-id="element-225">
          Trusted by data teams at
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-8 opacity-50 grayscale" data-id="element-226">
          {COMPANIES.map(company => <div key={company} className="text-xl font-bold tracking-tighter text-zinc-400" data-id="element-227">
              {company}
            </div>)}
        </div>
      </div>
    </section>;
}